// Module
var code = `<!-- clTable — tabular data rendered via one-level nested loops.
     Data shape (from author):
         { caption?: "markdown", headers: ["h1", "h2"], rows: [["a1", "a2"], ["b1", "b2"]] }

     Pipeline normalization:
         rows → [{ cells: ["a1", "a2"] }, { cells: ["b1", "b2"] }]

     The normalization is required because DomElementTemplate's inner loop needs a
     property name (\`cells\`) to iterate. The author-facing JSON shape is intentionally
     array-of-arrays — it matches how people mentally model tabular data. -->
<figure class="block-cl-table">
  <table class="block-cl-table__table">
    <thead>
      <tr>{{#headers}}<th class="block-cl-table__header">{{.}}</th>{{/headers}}</tr>
    </thead>
    <tbody>
      {{#rows}}
      <tr>{{#cells}}<td class="block-cl-table__cell">{{.}}</td>{{/cells}}</tr>
      {{/rows}}
    </tbody>
  </table>
  {{#caption}}<figcaption class="block-cl-table__caption">{{caption}}</figcaption>{{/caption}}
</figure>
`;
// Exports
module.exports = code;